__webpack_require__.p = "https://webid.cdn.garenanow.com/assets/milestone.shop.garena.tw/";